module.exports = __webpack_public_path__ + "static/media/fleetprocure--logo.6d4632f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/fleetprocure/fleetprocure--logo.svg
// module id = 163
// module chunks = 0